export default "__VITE_ASSET__BpRLDiA8__"